import { render, staticRenderFns } from "./home.vue?vue&type=template&id=7c4f6fdc"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=7c4f6fdc&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4f6fdc')) {
      api.createRecord('7c4f6fdc', component.options)
    } else {
      api.reload('7c4f6fdc', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=7c4f6fdc", function () {
      api.rerender('7c4f6fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/home.vue"
export default component.exports